interface GetScheduleErrorArgs {
  date: Date | null;
  isComplete: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
}

export const getScheduleError = ({ date, isComplete, minDate, maxDate }: GetScheduleErrorArgs) => {
  if (!isComplete) {
    return null;
  }

  if (!date) {
    return 'schedule.error-invalid';
  }

  if (date.getTime() < Date.now()) {
    return 'schedule.error-past';
  }

  if (minDate && date.getTime() <= minDate.getTime()) {
    return 'schedule.error-out-of-range';
  }

  if (maxDate && date.getTime() >= maxDate.getTime()) {
    return 'schedule.error-out-of-range';
  }

  return null;
};
